import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { focusResultsList } from '@Components/Results/resultListIds';

export default function useFilterActionFocus({
  activeResultName,
  hasSelectedFilters,
  renderPanelAsModal,
  resultsLoading,
  showFilterAppliedNudge,
}) {
  const [focusRequest, setFocusRequest] = useState(null);
  const drawerHeadingRef = useRef(null);
  const filterNudgePrimaryActionRef = useRef(null);

  const handleApplyComplete = useCallback(({ result, shouldRestoreFocus }) => {
    const resultName = result?.searchFilterResult?.resultName;
    if (shouldRestoreFocus && result?.hasResults && resultName) {
      setFocusRequest({ type: 'apply', resultName });
    }
  }, []);

  const handleClearComplete = useCallback(({ result, shouldRestoreFocus }) => {
    if (shouldRestoreFocus && result) {
      setFocusRequest({ type: 'clear' });
    }
  }, []);

  useLayoutEffect(() => {
    if (!focusRequest) return;

    if (focusRequest.type === 'clear') {
      if (hasSelectedFilters) return;
      drawerHeadingRef.current?.focus();
      setFocusRequest(null);
      return;
    }

    if (activeResultName !== focusRequest.resultName) return;

    if (showFilterAppliedNudge) {
      filterNudgePrimaryActionRef.current?.focus();
      setFocusRequest(null);
      return;
    }

    // A modal panel cannot send focus behind its active focus trap. When there is no Assistant
    // replacement prompt, keep focus at the stable Filters heading until the panel is closed.
    if (renderPanelAsModal) {
      drawerHeadingRef.current?.focus();
      setFocusRequest(null);
      return;
    }

    if (resultsLoading) return;

    if (!focusResultsList()) {
      drawerHeadingRef.current?.focus();
    }
    setFocusRequest(null);
  }, [activeResultName, focusRequest, hasSelectedFilters, renderPanelAsModal, resultsLoading, showFilterAppliedNudge]);

  return {
    drawerHeadingRef,
    filterNudgePrimaryActionRef,
    handleApplyComplete,
    handleClearComplete,
  };
}
